import { API, api } from "./api";

export const ROLE_LABELS = {
  suporte: "Suporte",
  admin: "Administrador", diretor: "Diretor / Broker", consultor: "Consultor",
  assistente: "Assistente Administrativo", leitura: "Utilizador de Leitura",
};

export const PROPERTY_TYPES = {
  apartamento: "Apartamento", moradia: "Moradia", terreno: "Terreno", loja: "Loja", escritorio: "Escritório",
  armazem: "Armazém", predio: "Prédio", garagem: "Garagem", quinta: "Quinta", empreendimento: "Empreendimento", outro: "Outro",
};

export const PURPOSES = { venda: "Venda", arrendamento: "Arrendamento", venda_arrendamento: "Venda e arrendamento" };

export const PROPERTY_STATUS = {
  em_preparacao: "Em preparação", disponivel: "Disponível", reservado: "Reservado", em_negociacao: "Em negociação",
  vendido: "Vendido", arrendado: "Arrendado", retirado: "Retirado do mercado",
};

export const STATUS_COLORS = {
  em_preparacao: "bg-slate-700/60 text-slate-200 border-slate-600",
  disponivel: "bg-emerald-500/15 text-emerald-300 border-emerald-500/40",
  reservado: "bg-amber-500/15 text-amber-300 border-amber-500/40",
  em_negociacao: "bg-sky-500/15 text-sky-300 border-sky-500/40",
  vendido: "bg-[#C9A84C]/20 text-[#E0C574] border-[#C9A84C]/40",
  arrendado: "bg-violet-500/15 text-violet-300 border-violet-500/40",
  retirado: "bg-red-500/10 text-red-300 border-red-500/30",
  recebido: "bg-sky-500/15 text-sky-300 border-sky-500/40",
  por_verificar: "bg-amber-500/15 text-amber-300 border-amber-500/40",
  validado: "bg-emerald-500/15 text-emerald-300 border-emerald-500/40",
  em_falta: "bg-red-500/10 text-red-300 border-red-500/30",
  expirado: "bg-red-500/20 text-red-300 border-red-500/50",
  desatualizado: "bg-orange-500/15 text-orange-300 border-orange-500/40",
  novo: "bg-sky-500/15 text-sky-300 border-sky-500/40",
  contactado: "bg-slate-700/60 text-slate-200 border-slate-600",
  qualificado: "bg-emerald-500/15 text-emerald-300 border-emerald-500/40",
  visita_agendada: "bg-amber-500/15 text-amber-300 border-amber-500/40",
  proposta_apresentada: "bg-violet-500/15 text-violet-300 border-violet-500/40",
  convertido: "bg-[#C9A84C]/20 text-[#E0C574] border-[#C9A84C]/40",
  inativo: "bg-red-500/10 text-red-300 border-red-500/30",
};

export const DOC_STATUS = {
  recebido: "Recebido", por_verificar: "Por verificar", validado: "Validado",
  em_falta: "Em falta", expirado: "Expirado", desatualizado: "Desatualizado",
};

export const CLIENT_TYPES = {
  comprador: "Comprador", potencial_comprador: "Potencial comprador", arrendatario: "Arrendatário",
  investidor: "Investidor", outro: "Outro",
};

export const CLIENT_STATUS = {
  novo: "Novo", contactado: "Contactado", qualificado: "Qualificado", visita_agendada: "Visita agendada",
  proposta_apresentada: "Proposta apresentada", convertido: "Convertido", inativo: "Inativo",
};

export const OWNER_STATUS = { prospecao: "Em prospeção", ativo: "Ativo", em_negociacao: "Em negociação", inativo: "Inativo" };

export const ENERGY_CLASSES = ["A+", "A", "B", "B-", "C", "D", "E", "F", "Isento"];
export const PHOTO_CATEGORIES = ["Geral", "Sala", "Cozinha", "Quarto", "Casa de banho", "Exterior", "Vista", "Varanda/Terraço", "Outro"];
export const CONTACT_PREFS = { telefone: "Telefone", email: "Email", whatsapp: "WhatsApp", presencial: "Presencial" };

export const fmtDate = (iso) => {
  if (!iso) return "—";
  const d = iso.slice(0, 10).split("-");
  return d.length === 3 ? `${d[2]}/${d[1]}/${d[0]}` : iso;
};

export const fmtDateTime = (iso) => (iso ? `${fmtDate(iso)} ${iso.slice(11, 16)}` : "—");

export const authUrl = (path) => `${API}${path}?auth=${localStorage.getItem("almar_token")}`;

export const canCreate = (u) => ["admin", "diretor", "consultor"].includes(u?.role);
export const isManager = (u) => ["admin", "diretor"].includes(u?.role);
export const canDocs = (u) => u?.role !== "leitura";

export const numOrNull = (v) => (v === "" || v === null || v === undefined ? null : Number(v));

export const lookupPostal = async (cp) => {
  if (!/^\d{4}-\d{3}$/.test(cp || "")) return null;
  try { const { data } = await api.get(`/re/postal/${cp}`); return data; } catch { return null; }
};
